import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'partner',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa partnera',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    email: {
      title: 'Login partnera (e-mail) *',
      type: 'string',
      format: 'email',
      fieldRequired: true,
      validationMessages: {
        format: 'Niepoprawny adres e-mail'
      }
    },
    website: {
      title: 'Strona internetowa',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: false
    },
    woj: {
      title: 'Województwo',
      type: 'string',
      fieldRequired: false
    },
    pow: {
      title: 'Powiat',
      type: 'string',
      fieldRequired: false
    },
    gmi: {
      title: 'Gmina',
      type: 'string',
      fieldRequired: false
    },
    terc: {
      title: 'Kod TERC',
      type: 'string',
      fieldRequired: false
    },
    city: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: false
    },
    simc: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: false
    },
    street: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: false
    },
    ulic: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: false
    },
    postalCode: {
      title: 'Kod pocztowy',
      type: 'string',
      format: 'kod',
      fieldRequired: false,
      validationMessages: {
        format: 'Niepoprawny kod pocztowy'
      }
    },
    homeNumber: {
      title: 'Numer budynku',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    },
    localNumber: {
      title: 'Numer lokalu',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    },
    images: {
      title: 'Galeria',
      type: 'string',
      default: ''
    },
    mainImage: {
      title: 'Avatar',
      type: 'number'
    },
    backgroundImage: {
      title: 'Obrazek tła',
      type: 'number'
    },
    descriptionShort: {
      type: 'string',
      maxLength: 500,
      fieldRequired: false
    }
  }
};
